export default __webpack_public_path__ + "static/media/internalbleed1.4460a79b.png";